import { ofType } from "redux-observable";
import { EMPTY, of } from "rxjs";
import { switchMap, switchMapTo } from "rxjs/operators";
import { selectShopMinOfferTimestamp } from "../../../selectors/selectShopInfo";
import { utilTick } from "../../../utils/utilTick";
import { utilTime } from "../../../utils/utilTime";
import { TypeActionAuth } from "../../auth/actionAuth";
import { actionShopRequestUpdate } from "../../shop/actionShop";
export var epicTimeShop = function (action$, state$) {
    return action$.pipe(ofType(TypeActionAuth.Login), switchMapTo(utilTick.second$), switchMap(function () {
        var state = state$.value;
        var timestamp = selectShopMinOfferTimestamp(state);
        var secondsLeft = utilTime.secondsLeftTill(timestamp);
        if (secondsLeft < 0) {
            return of(actionShopRequestUpdate());
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/time/epics/epicTimeShop.ts
// module id = 2439
// module chunks = 3